module.exports = __webpack_public_path__ + "img/Dg-Reg.10e85e58.svg";